import React, { useContext } from 'react';
import { AuthContext } from '../../navigation/AuthProvider';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { LoginAccountFind } from './LoginAccountFind';
import { LoginFindSuccess } from './LoginFindSuccess';

export const LoginForgetMain = (oProps: any) => {
  const navigate = useNavigate();
  const [findIdSuccess, setFindIdSuccess] = React.useState<boolean>(false);
  const [findPasswordSuccess, setFindPasswordSuccess] = React.useState<boolean>(false);
  const [findId, setFindId] = React.useState<any[]>([]);
  const [authenticationKey, setAuthenticationKey] = React.useState<number>(0);
  const [storeId, setStoreId] = React.useState<number>(0);
  // const [title, setTitle] = React.useState<string>('아이디 / 비밀번호 찾기');

  const moveLoginPage = () => {
    navigate('/');
  };
  const moveFindPasswordPage = () => {
    setFindIdSuccess(false);
    setFindPasswordSuccess(false);
    navigate('/loginPasswordForget');
  };

  return (
    <Style>
      <div className="wrap">
        <div className="loginForgetContainer">
          <div className="content">
            <button onClick={moveLoginPage} className="logo">
              <img
                src={`${process.env.PUBLIC_URL}/img/knock_wide_logo.png`}
                alt="logo"
                width="200px"
              />
            </button>
            {!findIdSuccess && !findPasswordSuccess ? (
              <LoginAccountFind
                setFindIdSuccess={setFindIdSuccess}
                setFindPasswordSuccess={setFindPasswordSuccess}
                typeForgot={oProps.typeForgot}
                moveLoginPage={moveLoginPage}
                setFindId={setFindId}
                setAuthenticationKey={setAuthenticationKey}
                authenticationKey={authenticationKey}
                setStoreId={setStoreId}
              />
            ) : (
              <LoginFindSuccess
                findIdSuccess={findIdSuccess}
                findPasswordSuccess={findPasswordSuccess}
                findId={findId}
                typeForgot={oProps.typeForgot}
                moveLoginPage={moveLoginPage}
                moveFindPasswordPage={moveFindPasswordPage}
                storeId={storeId}
                authenticationKey={authenticationKey}
              />
            )}
          </div>
          <div className="footer">
            <div className="serviceCenter">
              <p>고객센터</p>
              <p>cs@ivid.kr</p>
            </div>
            <p>Copyright 2025. Invisible Ideas. All rights reserved</p>
          </div>
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  ul,
  li {
    list-style: none;
  }
  .wrap {
    width: 100%;
    height: 100dvh;
    background: #f7f7f7;
  }
  .loginForgetContainer {
    width: 100%;
    max-width: 30rem;
    margin: 0 auto;
    height: 100dvh;
    padding: 3rem !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .content {
    width: 100%;

    .logo {
      width: 100%;
      margin-bottom: 40px;
      border: none;
      outline: none;
      background: none;
    }
  }
  h1 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #4f5459;
  }
  button,
  label,
  label > input {
    cursor: pointer;
  }

  .title {
    margin-top: 3.5rem;
    margin-bottom: 2rem;
  }

  /* 로그인페이지 이동*/
  .backPageButton {
    width: 100%;
    border: none;
    outline: none;

    p {
      font-size: 0.875rem;
      font-weight: 400;
      color: #979797;
    }
  }

  /* footer */
  .footer {
    width: 100%;
    .serviceCenter {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 24px;
    }
    p {
      margin: 20px 0;
      font-size: 14px;
      font-weight: 400;
      color: #a7a7a7;
      text-align: center;
    }
  }

  @media (max-width: 800px) {
    .wrap {
      max-height: calc(var(--vh, 1vh) * 100);
    }
    .container {
      width: 100%;
      max-width: 100%;
      padding: 20px !important;
    }
    .title {
      margin-top: 32px;
      margin-bottom: 20px;
    }
    .loginFind {
      button {
        margin-left: 8px;

        p {
          font-size: 12px;
        }
      }
    }
    .footer {
      p {
        font-size: 12px;
      }
    }
  }
`;
